import { call, takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getRecommendedList } from '../api';

/**
 * Web replacement for mobile's `getCurrentPositionJson` (from
 * store/modules/location/saga, which doesn't exist on web). Resolves to a
 * GeoJSON-style Point the same shape the backend expects: { type: 'Point',
 * coordinates: [longitude, latitude] }. Resolves to null if geolocation is
 * unavailable or denied — callers should treat that as "no location filter".
 */
const getCurrentPositionJson = () =>
  new Promise(resolve => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => {
        resolve({
          type: 'Point',
          coordinates: [position.coords.longitude, position.coords.latitude],
        });
      },
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 },
    );
  });

export function* callRecommendedList(params) {
  const curPositionJsonPoint = yield call(getCurrentPositionJson);
  const response = yield call(getRecommendedList, curPositionJsonPoint, params);
  return response;
}

export const getRecommendedListSaga = getPaginatedListSaga(actions, callRecommendedList);

export default function* saga() {
  yield takeLatest(types.GET_RECOMMENDED_LIST, getRecommendedListSaga);
}
